module.exports = __webpack_public_path__ + "static/media/instrumentacion-02.f5d2822c.jpg";